<template>
  <div>{{displayNum}}</div>
</template>

<script>
    import { getDate } from "../../common/tool";
    import {getFormatNumber, getRandomDuration} from "./count";

    export default {
        name: 'CountByMinute',
        props: {
            config: Object,
            start: String,
            end: String,
            status: Number,
            statusText: String,
            showStart: Boolean,
            speed: {
                type: Array,
                default() {
                    return [5, 10];
                }
            },
            simple: Boolean, // 是否简要展示
            cache: Boolean, // 是否缓存
        },
        data() {
            return {
                current: Date.now(),
                count: 0,
                timer: null,
                minutes: 0,
                mc: 0,
                mn: 0
            }
        },
        computed: {
            number() {
                return this.config ? this.config.number || 0 : 0;
            },
            range() {
                return this.config ? this.config.range || [] : [];
            },
            startTime() {
                return this.start ? getDate(this.start) : null;
            },
            endTime() {
                return this.end ? getDate(this.end) : null;
            },
            // 简要展示每1分钟更新一次
            duration() {
                return this.simple ? 60000 : 5000;
            },
            // 优化展示数字
            displayNum() {
                return getFormatNumber(this.count) + '人看过';
            },
        },
        watch: {
            // 监听视频的变化修改相应的人数
            config() {
                this.init();
            },
            start() {
                this.init();
            },
            end() {
                this.init();
            },
        },
        created() {
            this.init();
        },
        beforeDestroy() {
            this.clearTimer();
        },
        methods: {
            init() {
                this.clearTimer();
                if(this.number > 0) {
                    this.setCount();
                    this.timer = setInterval(this.setCount, getRandomDuration(this.speed));
                }
            },
            clearTimer() {
                if(this.timer)  {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            },
            // 计算当前分钟的浏览量
            getMinutesCount(minutes) {
                // 分钟数和上次计算的分钟一样 直接取缓存的值返回
                if(this.cache && this.minutes && minutes == this.minutes) {
                    return {num: this.mn, count: this.mc};
                } else {
                    const number = this.number;
                    const range = this.range;
                    let time = minutes;
                    //当前时间点每分钟增加数
                    let num = number;
                    let count = 0;
                    range.forEach(r => {
                        if(r.start < minutes) {
                            const ro = (r.end > time ? time : r.end) - r.start;
                            const n = Math.round(ro * r.number);
                            if (n > 0) {
                                count += n;
                                time -= ro;
                            }
                            // 当前分钟在这个区间
                            if(minutes < r.end) {
                                num = r.number
                            }
                        }
                    });
                    if(time > 0) {
                        if (time > 0) {
                            count += Math.round(time * number);
                        }
                    }
                    this.minutes = minutes;
                    if (this.cache) {
                        this.mc = count;
                        this.mn = num;
                    }
                    return {num, count};
                }
            },
            setCount() {
                let current = Date.now();
                const startTime = this.startTime.getTime();
                const endTime = this.endTime.getTime();
                if (current > startTime) {
                    if(current > endTime) {
                        this.clearTimer();
                        current = endTime;
                    }
                    const offset = current - startTime;
                    // 开始了多少分钟
                    let minutes = Math.floor(offset / 60000);
                    // 剩余多少秒
                    const seconds = offset % 60000;
                    let {num, count} = this.getMinutesCount(minutes);
                    count += Math.round(num * seconds / 60000);
                    this.count = count;
                }
                this.current = current;
            }
        }
    }
</script>

<style lang="less">

</style>
